export enum LocationTypeEnum {
    City = 'city',
    Voivodeship = 'voivodeship',
    Region = 'region',
    Country = 'country',
    Accommodation = 'accommodation',
    POI = 'poi',
}

export type LocationType = `${LocationTypeEnum}`;

export const LOCATION_TYPES = Object.values(LocationTypeEnum) as LocationType[];

export function isValidLocationType(value: string): value is LocationType {
    return LOCATION_TYPES.includes(value as LocationType);
}
